import { Card, Container, Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import SessionEdit from './SessionEdit';

const SessionShow = () => {

    let {id} = useParams();

    return (
        
        <Container fluid>
            <Row>
                <Col>
                    <Card>
                        <SessionEdit id={id}/>
                    </Card>
                </Col>
            </Row>
        </Container>
    );

}

export default SessionShow;